import React from "react";
import { Button, ButtonProps } from "react-bootstrap";
import { ArrowPathIcon } from "@heroicons/react/20/solid";

type LoaderButtonProps = ButtonProps & {
  isLoading: boolean;
  text: string;
  loadingText: string;
  className: string;
  disabled?: boolean;
};

export default ({
  isLoading,
  text,
  loadingText,
  className = "",
  disabled = false,
  ...props
}: LoaderButtonProps) => {
  return (
    <Button
      className={`LoaderButton ${className} flex items-center`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && (
        <ArrowPathIcon className="h-5 w-5 spinning animate-spin mr-2" />
      )}
      {!isLoading ? text : loadingText}
    </Button>
  );
};
